module.exports = __webpack_public_path__ + "static/img/cod.aadb244.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payment/cod.svg
// module id = yDoQ
// module chunks = 31